import * as Application from 'expo-application';

export const getMobileAppVersion = async (): Promise<string> => {
  return Promise.resolve(Application.nativeApplicationVersion || '');
};
